<template>
    <Form
      :show-message="showMessage"
      :model="actionData"
      :rules="rules">
      <FormItem prop="reportType">
        <data-list url="topic/report-type-list">
          <van-radio-group v-model="actionData.reportType" slot-scope="scope">
            <div v-for="{id, content} of scope.data" :key="id">
              <van-radio :name="id" icon-size=".7rem" checked-color="#d9b581">{{ content }}</van-radio>
            </div>
          </van-radio-group>
        </data-list>
      </FormItem>
      <FormItem prop="reason" class="textarea">
        <i-input type="textarea" v-model="actionData.reason" placeholder="举报理由" :rows="5"/>
      </FormItem>
    </Form>
  </template>
  
  <script type="text/javascript">
  export default {
    data () {
      return {
        url: 'topic/report',
        actionData: {
          topicId: this.selection.topicId,
          replyId: this.selection.replyId,
          reportType: undefined,
          reason: null
        }
      }
    },
    computed: {
      rules () {
        return {
          reason: {
            required: true,
            message: '请填写原因'
          }
        }
      }
    },
    methods: {
      _validate() {
          return new Promise((resolve, reject) => {
            const {reportType,reason} = this.actionData;
            if (!reportType) {
              reject(new Error("请选择举报原因"));
              return
            }else if(reason == ''|| reason == null) {
              reject(new Error("请填写原因"));
              return
            } else {
              window.setTimeout(resolve, 600);
            }
          });
        }
    },
  }
  </script>
  
  <style lang="less" scoped>
    
  </style>
  
